export interface ProjectKeywordVariantGq {
  id: number;
  variant: string;
  selectedByAlgorithm: boolean;
  selectedManually: boolean;
}

export const ProjectKeywordVariantGqProps = `
  id
  variant
  selectedByAlgorithm
  selectedManually
`;
